import React, { useState } from 'react';

function HamburgerMenu({ currentPage, isLoggedIn, navigateTo, userProfile }) {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { id: 'landing', label: 'Home', page: 'landing', icon: '🏠' },
    { id: 'difficulty', label: "Today's Puzzle", page: 'difficulty', icon: '🎯' },
    { id: 'leaderboard', label: 'Leaderboard', page: 'leaderboard', icon: '🏆' },
    { id: 'founder', label: 'Founder Programme', page: 'founder', icon: '⭐' },
    { id: 'about', label: 'About', page: 'about', icon: 'ℹ️' }
  ];

  // Add admin link if user is admin
  if (userProfile?.is_admin) {
    navLinks.push({ id: 'admin', label: 'Admin Portal', page: 'admin', icon: '⚙️' });
  }

  const handleNavigate = (page) => {
    setIsOpen(false);
    navigateTo(page);
  };

  return (
    <>
      {/* Hamburger Button - Fixed Position */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: 'fixed',
          top: '20px',
          right: '16px',
          zIndex: 1001,
          background: isOpen ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          color: 'white',
          width: '44px',
          height: '44px',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '24px',
          transition: 'all 0.2s ease',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
        }}
      >
        {isOpen ? '✕' : '☰'}
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.6)',
            zIndex: 999,
            animation: 'fadeIn 0.2s ease'
          }}
        />
      )}

      {/* Slide-out Menu */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: isOpen ? 0 : '-100%',
          width: '280px',
          maxWidth: '85vw',
          height: '100vh',
          background: 'white',
          zIndex: 1000,
          transition: 'right 0.3s ease',
          boxShadow: isOpen ? '-4px 0 20px rgba(0, 0, 0, 0.3)' : 'none',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '24px 20px',
          borderBottom: '1px solid #E5E7EB',
          background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)'
        }}>
          <h2 style={{
            margin: '0',
            color: 'white',
            fontSize: '20px',
            fontWeight: '800',
            letterSpacing: '-0.5px'
          }}>
            SudokuMatch
          </h2>
          <p style={{
            margin: '4px 0 0 0',
            color: 'rgba(255, 255, 255, 0.8)',
            fontSize: '13px',
            fontWeight: '500'
          }}>
            Daily Sudoku. Played Fair.
          </p>
        </div>

        {/* Navigation Links */}
        <div style={{
          flex: 1,
          padding: '16px 0'
        }}>
          {navLinks.map(link => (
            <button
              key={link.id}
              onClick={() => handleNavigate(link.page)}
              style={{
                width: '100%',
                padding: '16px 20px',
                background: currentPage === link.page ? '#F9FAFB' : 'transparent',
                border: 'none',
                borderLeft: currentPage === link.page ? '4px solid #FF8C00' : '4px solid transparent',
                color: currentPage === link.page ? '#1F2937' : '#4B5563',
                fontSize: '16px',
                fontWeight: currentPage === link.page ? '600' : '500',
                cursor: 'pointer',
                textAlign: 'left',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (currentPage !== link.page) {
                  e.target.style.background = '#F9FAFB';
                }
              }}
              onMouseLeave={(e) => {
                if (currentPage !== link.page) {
                  e.target.style.background = 'transparent';
                }
              }}
            >
              <span style={{ fontSize: '20px' }}>{link.icon}</span>
              <span>{link.label}</span>
            </button>
          ))}
        </div>

        {/* Footer - Login/Account Button */}
        <div style={{
          padding: '16px 20px',
          borderTop: '1px solid #E5E7EB'
        }}>
          <button
            onClick={() => handleNavigate(isLoggedIn ? 'account' : 'login')}
            style={{
              width: '100%',
              padding: '14px',
              background: '#FF8C00',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '16px',
              fontWeight: '700',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 140, 0, 0.4)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#E07B00';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#FF8C00';
            }}
          >
            {isLoggedIn ? '👤 My Account' : 'Login / Register'}
          </button>
          
          {isLoggedIn && (
            <button
              onClick={() => {
                setIsOpen(false);
                alert('Logging out...');
              }}
              style={{
                width: '100%',
                padding: '12px',
                background: 'transparent',
                color: '#6B7280',
                border: 'none',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                marginTop: '8px'
              }}
            >
              Log Out
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default HamburgerMenu;
